import { Box, Button, IconButton, Grid } from '@mui/material';
import MaterialTable from 'material-table';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Popup from "../../../Base/views/Popup"
import { useState } from 'react';
import ConfirmationDialog from '../../../Base/views/ConfirmationDialog';
import { DeleteOTAction, GetOTAction } from '../../../../../store/Finance/PayRollTemplate/Action';
import OverTime from './OverTime';

const OverTimeGrid = () => {
    const dispatch = useDispatch();
    const { ot_data, isLoadingOT } = useSelector(state => state.FinanceReducer?.PayrollTemplateReducer);
    const [editedRecord, setEditedRecord] = useState(null);
    const [openPopup, setOpenPopup] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [currentData, setCurrentData] = useState({});
  useEffect(() => {
            dispatch(GetOTAction());
          // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [])

    const handleEdit = (rowData) => {
        setEditedRecord(rowData);
        setOpenPopup(true);
    };

    const handleConfirmDelete = (rowData) => {
        setOpenDialog(true);
        setCurrentData(rowData)
    };

    const handleAdd = () => {
        setEditedRecord()
        setOpenPopup(true);
    };

    const handleDelete = () => {
        setOpenDialog(false);
        dispatch(DeleteOTAction({ overtime_configuration_id: currentData?.overtime_configuration_pk }))
    };

    const addMode = (resetForm) => {
        resetForm();
        setEditedRecord(null);
        setOpenPopup(false);
    };

    const addButton =     (<Button onClick={handleAdd} variant="contained" className="mpl-primary-btn" startIcon={<AddIcon />} >
        Add
    </Button>);

    return (
        <Grid container spacing={2} style={{ padding: "10px 0px" }}>
            <Grid item xs={12} md={12}>
                <Box>
                    <MaterialTable
                        isLoading={isLoadingOT}
                        columns={[
                            { title: "Overtime Code", field: "alias_name", cellStyle: { padding: "10px 10px 10px 13px" } },
                            { title: "Overtime Type", field: "overtime_type", cellStyle: { padding: "10px 10px 10px 13px" } },
                            // { title: "Overtime Policy", field: "overtime_policy", cellStyle: { padding: "10px 10px 10px 13px" } },
                            { 
                                title: "Earning Components", 
                                field: "variable_earning_components", 
                                cellStyle: { padding: "10px 10px 10px 13px" },
                                 render: rowData => {
                                    try {
                                        if (!rowData?.variable_earning_components) return "NA";
                                        const arr = typeof rowData?.variable_earning_components === "string"
                                            ? JSON.parse(rowData?.variable_earning_components)
                                            : rowData?.variable_earning_components;
                                        if (!arr || !Array.isArray(arr) || arr.length === 0) return "NA";
                                        return arr.map(item => item.label).join(", ");
                                    } catch {
                                        return "NA";
                                    }
                                },                            }
                        ]}
                        data={ot_data}
                        options={{
                            maxBodyHeight: 220,
                            rowStyle: { fontSize: "13px" },
                            headerStyle: { padding: "5px 10px", fontWeight: "bold" },
                            sorting: false,
                            search: false,
                            searchFieldAlignment: "right",
                            searchAutoFocus: true,
                            searchFieldVariant: "standard",
                            filtering: false,
                            paging: false,
                            selection: false,
                            actionsColumnIndex: -1,
                            grouping: false,
                            addRowPosition: "first",
                        }}
                        onSelectionChange={(rows) => { return (rows.filter(row => row?.status === "Submitted")) }}
                        actions={[
                            {
                                icon: () => <IconButton sx={{ padding: "0px" }}><EditIcon /></IconButton>,
                                tooltip: "Edit",
                                onClick: (_event, rowData) => { handleEdit(rowData) },
                            },
                            {
                                icon: () => <IconButton sx={{ padding: "0px" }}><DeleteIcon /></IconButton>,
                                tooltip: "Delete",
                                onClick: (_event, rowData) => { handleConfirmDelete(rowData) },
                            },
                        ]}
                        title={""}
                        components={{
                            Toolbar: props => (
                                <Box
                                    sx={{
                                        minHeight: "10px",
                                        padding: "10px 16px",
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                    }}
                                    >
                                    {addButton}
                                </Box>
                            )
                        }}
                    />
                    <Popup
                        fullWidth={true}
                        maxWidth="sm"
                        title={editedRecord ? "Edit" : "Add"}
                        openPopup={openPopup}
                        setOpenPopup={setOpenPopup}

                    >
                        <OverTime editedRecord={editedRecord} addMode={addMode} setOpenPopup={setOpenPopup} />
                    </Popup>
                    <ConfirmationDialog
                        title="Do you wish to proceed?"
                        openDialog={openDialog}
                        closeDialog={setOpenDialog}
                        popupTitle="Country Management"
                        OkButtonText="Delete"
                        onSubmit={handleDelete}
                    />
                </Box>
            </Grid>
        </Grid>
    );
}

export default OverTimeGrid;
